import React, { useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../app/PageTitleContext'
import { PersonContext } from './PersonContext'
import { RelationshipCalculatorContext } from '../relationshipCalculator/RelationshipCalculatorContext'
import RelationshipCalculatorForm from '../relationshipCalculator/RelationshipCalculatorForm'

const PERSON_PREFIX = 'p'

const PersonRelationshipCalculator = () => {
  usePageView({ page_detail: 'DMConsole:PersonRelationshipCalculator' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.relationshipCalculator'))
  const { currentPerson } = useContext(PersonContext)
  const relCalculatorContext = useContext(RelationshipCalculatorContext)

  const updateCalculatorContext = () => {
    // right has the current pid the first time
    if (relCalculatorContext.summary || !relCalculatorContext.insetInlineEnd.inputId) {
      relCalculatorContext.insetInlineEnd.prefix = PERSON_PREFIX
      relCalculatorContext.insetInlineEnd.inputId = currentPerson.id
      relCalculatorContext.insetInlineEnd.validId = true
      relCalculatorContext.insetInlineEnd.personId = currentPerson.id
      const lifeSpan = currentPerson.lifeSpan
      if (lifeSpan !== null && lifeSpan !== undefined) {
        relCalculatorContext.insetInlineEnd.label = currentPerson.name.concat('(').concat(lifeSpan).concat(')')
      } else {
        relCalculatorContext.insetInlineEnd.label = currentPerson.name
      }
    }
    // left side is clear first time
    if (relCalculatorContext.summary || !relCalculatorContext.insetInlineStart.inputId) {
      relCalculatorContext.insetInlineStart.prefix = PERSON_PREFIX
      relCalculatorContext.insetInlineStart.inputId = ''
      relCalculatorContext.insetInlineStart.validId = false
      relCalculatorContext.insetInlineStart.personId = ''
      relCalculatorContext.insetInlineStart.label = ''
      relCalculatorContext.summary = false
    }
  }

  updateCalculatorContext()

  return <RelationshipCalculatorForm />
}
export default PersonRelationshipCalculator
